const VIMEO_HOSTS = new Set(["vimeo.com", "www.vimeo.com", "player.vimeo.com"]);

export function buildVimeoEmbedUrl(video) {
    if (video === null || video === undefined || video === "") return null;

    const rawVideo = String(video);
    let embedUrl;

    try {
        if (/^\d+$/.test(rawVideo)) {
            embedUrl = new URL(`https://player.vimeo.com/video/${rawVideo}`);
        } else {
            const parsed = new URL(rawVideo);
            if (!VIMEO_HOSTS.has(parsed.hostname.toLowerCase())) return null;

            const pathMatch = parsed.pathname.match(/(?:\/video)?\/(\d+)(?:\/([^/]+))?(?:\/|$)/);
            if (!pathMatch) return null;

            if (parsed.hostname.toLowerCase() === "player.vimeo.com") {
                embedUrl = new URL(parsed.toString());
            } else {
                embedUrl = new URL(`https://player.vimeo.com/video/${pathMatch[1]}`);
                const privateHash = parsed.searchParams.get("h") || pathMatch[2];
                if (privateHash) embedUrl.searchParams.set("h", privateHash);
            }
        }

        // Vimeo's documented startup controls: begin below AT&T Stream
        // Saver's typical limit, allow ABR up to 540p, and fetch initial
        // segments before the user presses play.
        embedUrl.searchParams.set("initial_quality", "360p");
        embedUrl.searchParams.set("max_quality", "540p");
        embedUrl.searchParams.set("preload", "auto");
        embedUrl.searchParams.set("playsinline", "1");

        return embedUrl.toString();
    } catch {
        return null;
    }
}

export function withVimeoStartupParams(url) {
    return buildVimeoEmbedUrl(url) || url;
}
